module.exports = __webpack_public_path__ + "img/stylist_revenue_icon.55736c84.svg";